
import { cva } from "class-variance-authority";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

// Gauge color variants based on score
const gaugeColorVariants = cva(
  "rounded-full flex items-center justify-center text-white font-bold",
  {
    variants: {
      score: {
        good: "bg-emerald-500",
        average: "bg-amber-500",
        poor: "bg-red-500",
      },
    },
    defaultVariants: {
      score: "average",
    },
  }
);

// Calculate score category
const getScoreCategory = (score: number) => {
  if (score >= 90) return "good";
  if (score >= 50) return "average";
  return "poor";
};

type GaugeProps = {
  title: string;
  score: number;
  description?: string;
};

export function Gauge({ title, score, description }: GaugeProps) {
  const scoreCategory = getScoreCategory(score);
  
  return (
    <div className="flex flex-col items-center text-center">
      <div className="relative h-32 w-32">
        {/* Gauge background */}
        <div className="absolute inset-0 rounded-full bg-muted"></div>
        
        {/* Gauge meter */}
        <div 
          className="absolute inset-0 rounded-full"
          style={{ 
            background: `conic-gradient(
              ${scoreCategory === 'good' ? 'rgb(16, 185, 129)' : 
                scoreCategory === 'average' ? 'rgb(245, 158, 11)' : 
                'rgb(239, 68, 68)'} ${score}%, 
              transparent ${score}%
            )`,
            clipPath: 'circle(50% at 50% 50%)'
          }}
        ></div>
        
        {/* Inner circle with score */}
        <div className="absolute inset-2 flex items-center justify-center">
          <div className={gaugeColorVariants({ score: scoreCategory }) + " h-24 w-24"}>
            <span className="text-2xl">{score}</span>
          </div>
        </div>
      </div>
      
      <h3 className="mt-2 font-medium">{title}</h3>
      {description && (
        <p className="mt-1 text-xs text-muted-foreground">{description}</p>
      )}
    </div>
  );
}
